export default "__VITE_ASSET__fed94493__"